import { inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { BackgroundTaskLaunchService } from '../../../../layout/store/background-tasks/background-task-launch.service';
import {
    BackgroundActionType,
    type VoucherExportBackgroundActionPayload,
} from '@libs/types/src/notifications/types/background-action.types';

@Injectable()
export class VoucherExportDialogStore extends ComponentStoreV2Factory {
    private readonly backgroundTaskLauncher = inject(
        BackgroundTaskLaunchService,
    );

    public start(
        payload: VoucherExportBackgroundActionPayload,
    ): Promise<boolean> {
        return this.backgroundTaskLauncher.start({
            type: BackgroundActionType.VOUCHER_EXPORT,
            payload,
            alreadyRunningMessage:
                'voucher.export.backgroundTask.messages.alreadyRunning',
            failedMessage: 'voucher.export.backgroundTask.messages.startFailed',
        });
    }
}
